// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.
import { DELAY_MS_HIDE, DELAY_MS_SHOW } from '../../util/config';

import TeamProfileCardTrigger from './TeamProfileCardTrigger';
export { DELAY_MS_HIDE, DELAY_MS_SHOW };
export default TeamProfileCardTrigger;
